import * as React from 'react';
import '../calendly.css';
import useFormatCalendlyUrl from '../../../hooks/useFormatCalendlyUrl';

import LoadingSpinner from './LoadingSpinner';

class ModalContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
    };

    this.onLoad = this.onLoad.bind(this);
  }

  onLoad() {
    this.setState({
      isLoading: false,
    });
  }

  render() {
    const src = useFormatCalendlyUrl({
      url: this.props.url,
      pageSettings: this.props.pageSettings,
      prefill: this.props.prefill,
      utm: this.props.utm,
      embedType: 'PopupWidget',
    });

    return (
      <React.Fragment>
        {this.state.isLoading && <LoadingSpinner />}
        <iframe
          width='100%'
          height='100%'
          frameBorder='0'
          title={this.props.iframeTitle || 'Calendly Scheduling Page'}
          onLoad={this.onLoad}
          src={src}
        ></iframe>
      </React.Fragment>
    );
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/components/Calendly/Modal/ModalContent.js